/**
 * Shared custom Recharts tooltip for Innovation Analytics charts.
 * Usage: <Tooltip content={<InnovationTooltip unit="innovations" />} />
 *
 * Props (from Recharts):
 *   active, payload, label
 * Custom props:
 *   unit — label for the count (e.g. "innovations", "joint innovations")
 *   labelKey — payload field to use as label (default: "name", falls back to label)
 */
export function InnovationTooltip({ active, payload, label, unit = 'innovations', labelKey = 'name' }) {
  if (!active || !payload?.[0]) return null;
  const d = payload[0].payload;
  const displayLabel = d[labelKey] || d.name || label || '';
  const value = payload[0].value;

  return (
    <div style={{
      background: '#fff',
      padding: '8px 12px',
      borderRadius: '8px',
      border: '1px solid #e5e7eb',
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      fontSize: '13px',
      lineHeight: 1.4,
    }}>
      <div style={{ fontWeight: 600, color: '#1e293b' }}>{displayLabel}</div>
      <div style={{ color: '#6b7280' }}>{value?.toLocaleString()} {unit}</div>
    </div>
  );
}
